
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

// GET
//  /yangcheng-test/Product/GetNeighborsList
// 睦邻首页推荐
/**
 * 睦邻首页显示 睦邻首页列表查询
 * @returns
 */
export const getProductHomeList = (data: any): Promise<any> => {
    return axios.get(`${baseURL}/Product/GetNeighborsList`, {params: data})
}
